export enum RolesEnum {
    CREATE_SERVICE_ORDER_ADMIN = 'create_service_order_admin',
    UPDATE_SERVICE_ORDER_ADMIN = 'update_service_order_admin',
    
    CREATE_REFUND_ADMIN = 'create_refund_admin',
    UPDATE_REFUND_ADMIN = 'update_refund_admin',
}
